<!-- 赞助详情 -->
<template>
  <div class="sponsorDet">
    <v-head :bg="'#272727'"></v-head>
    <div class="container" style="margin-top:60px;min-width:1200px;">
      <!-- logo-details -->
      <div class="sponsorDet-logohead">
        <div class="logohead-bread">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/sponsor' }">赞助</el-breadcrumb-item>
            <el-breadcrumb-item>{{ sponsorMsg.title }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="logohead-main">
          <div class="logohead-main-l">
            <img :src="sponsorMsg.picUrl" alt width="100%" height="100%" />
          </div>
          <div class="logohead-main-r">
            <div class="logohead-main-r-title">
              <img :src="sponsorMsg.enterpriseLogo" alt />
              {{ sponsorMsg.enterpriseName }}
            </div>
            <div class="logohead-main-r-msg">{{ sponsorMsg.companyProfile }}</div>
          </div>
        </div>
      </div>
      <!-- details 赞助详情 -->
      <div class="sponsorDet-details">
        <div class="details-title">赞助详情</div>
        <div class="details-main">
          <div class="details-line borderBtm">
            <div class="detailsCon">
              <div class="detailsCon-t">赞助方式</div>
              <div class="detailsCon-b">
                <span v-if="sponsorMsg.sponsorWay === 1">资金赞助</span>
                <span v-else-if="sponsorMsg.sponsorWay === 2">非资金赞助</span>
              </div>
            </div>
            <div class="detailsCon" v-if="sponsorMsg.sponsorWay === 1">
              <div class="detailsCon-t">金额</div>
              <div class="detailsCon-b">{{ sponsorMsg.money }}</div>
            </div>
            <div class="detailsCon" v-if="sponsorMsg.sponsorWay === 2">
              <div class="detailsCon-t">其他</div>
              <div class="detailsCon-b">查看赞助信息</div>
            </div>
            <div class="detailsCon">
              <div class="detailsCon-t">赞助单位</div>
              <div class="detailsCon-b">{{ sponsorMsg.sponsorEnterpriseName }}</div>
            </div>
          </div>
          <div class="details-line">
            <div class="detailsCon">
              <div class="detailsCon-t">赞助类型</div>
              <div class="detailsCon-b">{{ sponsorMsg.sponsorType }}</div>
            </div>
            <div class="detailsCon">
              <div class="detailsCon-t">赞助区域</div>
              <div class="detailsCon-b">{{ sponsorMsg.areaName }}</div>
            </div>
            <div class="detailsCon">
              <div class="detailsCon-t">赞助时间</div>
              <div class="detailsCon-b">{{ sponsorMsg.startDate }} - {{ sponsorMsg.endDate }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- message 赞助信息 -->
      <div class="sponsorDet-message">
        <div class="message-title">赞助信息</div>
        <div class="message-main" v-for="(item,index) of sponsorMsg.moduleList" :key="index">
          <div class="messageDetails">
            <div class="messageDetails-title">{{ item.title }}：</div>
            <div class="messageDetails-msg">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <!-- cooperation 合作信息 -->
      <div class="sponsorDet-cooperation">
        <div class="cooperation-title">合作信息</div>
        <div class="cooperation-main">
          <div class="cooperation-line">
            <div class="cooperationCon">
              <div class="cooperationCon-t">申请数量</div>
              <div class="cooperationCon-b">{{ sponsorMsg.applyNum }}</div>
            </div>
            <div class="cooperationCon">
              <div class="cooperationCon-t">合作数量</div>
              <div class="cooperationCon-b">{{ sponsorMsg.joinNum }}</div>
            </div>
            <div class="cooperationCon">
              <div class="cooperationCon-t">完成数量</div>
              <div class="cooperationCon-b">{{ sponsorMsg.dealNum }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <v-footer></v-footer>
  </div>
</template>
<script>
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
import icon1 from '@/assets/img/icon-sponsor-det/1.jpg'
import {
  Breadcrumb,
  BreadcrumbItem
} from 'element-ui'
export default {
  data () {
    return {
      img: icon1,
      sponsorMsg: {},
      sponsorId: this.$route.query.id
    }
  },
  components: {
    'v-head': vHead,
    'v-footer': vFooter,
    'el-breadcrumb': Breadcrumb,
    'el-breadcrumb-item': BreadcrumbItem
  },
  created () {
    // 移动端适配最小高度为浏览器高度
    this.$nextTick(() => {
      let containerDom = document.getElementsByClassName('container')[0]
      if (containerDom) {
        containerDom.style.minHeight = (document.documentElement.clientHeight - 100) + 'px'
      }
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$http({
        method: 'post',
        url: '/sponsor/case/info',
        params: {
          sponsorId: this.sponsorId
        }
      }).then(res => {
        if (res.code === 100) {
          this.sponsorMsg = res.result
        }
      }).catch(error => {
        console.log(error)
        return false
      })
    }
  }
}
</script>
<style src="./sponsor-det-native.scss" lang="scss"></style>
<style lang="scss" scoped>
.sponsorDet {
  width: 100%;
  height: 100%;
  overflow: hidden;
  // logo-details
  .sponsorDet-logohead {
    width: 100%;
    padding: 0 15%;
    box-sizing: border-box;
    .logohead-bread {
      padding: 20px 0;
      border-bottom: 1px solid #eeeeee;
    }
    .logohead-main {
      height: 350px;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: start;
      .logohead-main-l {
        height: 100%;
        width: 280px;
        padding: 35px 0;
        box-sizing: border-box;
      }
      .logohead-main-r {
        height: 100%;
        flex: 1;
        padding: 35px 60px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        .logohead-main-r-title {
          font-size: 14px;
          color: #333;
          font-weight: 700;
          padding: 8px 0;
          display: flex;
          flex-direction: row;
          align-items: center;
          img {
            width: 20px;
            height: 20px;
            background-color: #000000;
            margin-right: 12px;
          }
        }
        .logohead-main-r-msg {
          font-size: 12px;
          color: #666;
          font-weight: 400;
          line-height: 24px;
          padding: 8px 0;
        }
      }
    }
  }
  // details
  .sponsorDet-details {
    height: 300px;
    width: 100%;
    padding: 10px 15% 35px 15%;
    box-sizing: border-box;
    background-color: #f2f2f2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .details-title {
      height: 25%;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #2b2b2b;
      font-weight: 700;
    }
    .details-main {
      width: 100%;
      height: 75%;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      .details-line {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .detailsCon {
          width: 100%;
          height: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 15px 36px;
          box-sizing: border-box;
          border-right: 1px solid #f2f2f2;
          .detailsCon-t {
            font-size: 13px;
            color: #bfbcbc;
            padding: 8px 0;
          }
          .detailsCon-b {
            font-size: 12px;
            color: #666;
            padding: 8px 0;
            line-height: 20px;
          }
        }
      }
      .borderBtm {
        border-bottom: 1px solid #f2f2f2;
      }
    }
  }
  // message
  .sponsorDet-message {
    width: 100%;
    height: auto;
    padding: 10px 15% 35px 15%;
    box-sizing: border-box;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .message-title {
      padding: 25px 0;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #2b2b2b;
      font-weight: 700;
    }
    .message-main {
      width: 100%;
      height: 75%;
      border: 1px solid #f2f2f2;
      padding: 25px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 15px;
      .messageDetails {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        vertical-align: top;
        .messageDetails-title {
          white-space: nowrap;
          font-size: 12px;
          color: #333;
          margin-right: 5px;
          text-align: center;
          line-height: 32px;
          font-weight: bold;
        }
        .messageDetails-msg {
          font-size: 12px;
          color: #333;
          margin-right: 15px;
          line-height: 32px;
        }
      }
    }
  }
  // cooperation
  .sponsorDet-cooperation {
    height: 200px;
    width: 100%;
    padding: 10px 15% 35px 15%;
    box-sizing: border-box;
    background-color: #f2f2f2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .cooperation-title {
      height: 40%;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #2b2b2b;
      font-weight: 700;
    }
    .cooperation-main {
      width: 100%;
      height: 60%;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      .cooperation-line {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .cooperationCon {
          width: 100%;
          height: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 15px 36px;
          box-sizing: border-box;
          border-right: 1px solid #f2f2f2;
          .cooperationCon-t {
            font-size: 13px;
            color: #bfbcbc;
            padding: 8px 0;
          }
          .cooperationCon-b {
            font-size: 12px;
            color: #666;
            padding: 8px 0;
            line-height: 20px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/sponsor-det/sponsor-det.vue